import React from 'react';
import { FaSignOutAlt } from 'react-icons/fa';

export default function SidebarAccount({ name, subtitle, initials, photoUrl, collapsed = false, wrapName = false, onLogout }) {
  return (
    <div className={`sidebar__account${collapsed ? ' sidebar__account--collapsed' : ''}`}>
      <span className="sidebar__account-avatar" title={[name, subtitle].filter(Boolean).join(' · ')}>
        {photoUrl
          ? <img src={photoUrl} alt="" />
          : <span aria-hidden="true">{initials}</span>}
      </span>
      {!collapsed && (
        <div className="sidebar__account-identity">
          <div className={`sidebar__account-name${wrapName ? ' sidebar__account-name--wrap' : ''}`} title={name}>{name}</div>
          <div className="sidebar__account-subtitle" title={subtitle}>{subtitle}</div>
        </div>
      )}
      <button type="button" className="sidebar__account-logout" onClick={onLogout} aria-label="Log out" title="Log out">
        <FaSignOutAlt aria-hidden="true" />
      </button>
    </div>
  );
}
